const teamMembers = [
  {
    name: "Bhavani Alla",
    role: "Product Engineering Lead",
    focus: "Owns the overall experience and keeps releases predictable.",
  },
  {
    name: "Chandrashekhar Pichewar",
    role: "Frontend Engineer",
    focus: "Builds the React UI, focusing on accessibility and performance.",
  },
  {
    name: "Narmada Meka",
    role: "Backend Engineer",
    focus: "Designs APIs and keeps integrations reliable at scale.",
  },
  {
    name: "G R Kaushik Raj",
    role: "AI & Data Engineer",
    focus: "Creates the intelligent ride matching and chat experiences.",
  },
  {
    name: "Nagarjuna",
    role: "Platform Engineer",
    focus: "Keeps infrastructure resilient and observability actionable.",
  },
  {
    name: "Pranay",
    role: "Mobile Engineer",
    focus: "Delivers intuitive native experiences tuned for low bandwidth.",
  },
  {
    name: "Supriya Meka",
    role: "Product Designer",
    focus: "Shapes flows riders trust through research-informed design.",
  },
];

const DevTeam = () => {
  return (
    <section className="max-w-5xl mx-auto px-4 py-16 space-y-12 text-neutral-900">
      <div className="text-center space-y-4">
        <p className="text-sm uppercase tracking-[0.4em] text-[#22C55E]">
          Meet the crew
        </p>
        <h1 className="text-3xl md:text-4xl font-semibold">
          We are the Dev Team behind Duri
        </h1>
        <p className="text-base md:text-lg text-neutral-600">
          Our mission is to make intercity travel simpler, safer, and more
          sustainable. We experiment quickly, release often, and measure
          everything so riders can jump straight to the good part of a trip.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        <div className="rounded-2xl border border-neutral-200 p-6 shadow-sm bg-white">
          <h3 className="text-lg font-semibold mb-2">What drives us</h3>
          <p className="text-sm text-neutral-600">
            Reliability, trust, and speed. We blend human-centered design with
            practical engineering so every feature delivers immediate value.
          </p>
        </div>
        <div className="rounded-2xl border border-neutral-200 p-6 shadow-sm bg-white">
          <h3 className="text-lg font-semibold mb-2">How we work</h3>
          <p className="text-sm text-neutral-600">
            A tight feedback loop with riders and captains, async-friendly
            collaboration, and a playbook that keeps us shipping confidently.
          </p>
        </div>
        <div className="rounded-2xl border border-neutral-200 p-6 shadow-sm bg-white">
          <h3 className="text-lg font-semibold mb-2">What’s next</h3>
          <p className="text-sm text-neutral-600">
            Smarter matching, richer safety signals, and global-ready
            infrastructure to help millions more riders travel together.
          </p>
        </div>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        {teamMembers.map((member) => (
          <article
            key={member.name}
            className="rounded-2xl border border-neutral-200 bg-white p-6 shadow-sm space-y-2"
          >
            <h4 className="text-xl font-semibold">{member.name}</h4>
            <p className="text-sm font-medium text-[#22C55E]">{member.role}</p>
            <p className="text-sm text-neutral-600">{member.focus}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default DevTeam;

